import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { UserInfo } from '@/types/user';

interface UserState {
  user: UserInfo | null;
  token: string | null;
}

interface UserActions {
  setUser: (user: UserInfo | null) => void;
  getUsername: () => string | undefined;
  setToken: (token: string | null) => void;
  getToken: () => string | null;
}

const initialState: UserState = {
  user: null,
  token: null,
};

export const useUserStore = create(
  immer<UserState & UserActions>((set, get) => ({
    ...initialState,

    setUser: (user) => {
      set({ user });
    },

    getUsername: () => {
      return get().user?.username;
    },

    setToken: (token) => {
      set({ token });
    },

    getToken: () => {
      return get().token;
    },
  })),
);
